import { PLATFORM_NAME } from "@app/types/regix"
import { getParameters, useDarkMode } from "@app/utils";
import { Platform } from "react-native";

export const colorsForSupersetDezerv = {
      'white': '#ffffff',
      'black': '#000000',
      //text colors
      'milk': '#F5F5F3',
      'chalk': '#EAE9E5',
      'text-primary': '#E7E6E2',
      'text-secondary': '#A7A5A3',
      'text-placeholder': '#8E8D8B',
      'text-disabled': '#8E8D8B',
      'text-emphasis-secondary': '#808AD9',
      'text-action-primary': '#E7E6E2',
      'text-action-primary-hover': '#A7A5A3',
      'text-on-action-primary': '#0E0F10',
      'text-success': '#4EB3A9',
      'text-warning': '#E99E4E',
      'text-info': '#A7A5A3',
      'text-error': '#FF5757',

      //bg-colors
      'bg-surface-page':'#100F0F',
      'bg-surface-primary': '#100F0F',
      'bg-surface-secondary': '#31302E',
      'bg-surface-emphasis-primary': '#636363',
      'bg-surface-emphasis-secondary': '#4E5483',
      'bg-fill-primary': '#262524',
      'bg-fill-secondary': '#343739',
      'bg-fill-emphasis-primary-1': '#31302e',
      'bg-fill-emphasis-primary-2': '#31302e',
      'bg-fill-emphasis-secondary': '#323760',
      'bg-fill-success': '#0C2727',
      'bg-fill-warning': '#3D1A0D',
      'bg-fill-error': '#742525',
      'bg-fill-info': '#262524',
      'bg-action-primary':  '#FFFFFF',
      'bg-action-primary-hover': '#E7E6E2',
      'bg-action-disabled': '#31302E',

      //border
      'border-primary': '#343739',
      'border-secondary': '#31302E',
      'border-emphasis-primary':'#8E8D8B',
      'border-emphasis-secondary':'#3B4064',
      'border-form': '#575655',
      'border-success': '#204F4D',
      'border-warning': '#72371C',
      'border-info': '#31302E',
      'border-error': '#742525',
      'border-action': '#E7E6E2',
      'border-action-hover': '#BBB9B7',
      'border-focus': '#A7A5A3',
      'border-disabled': '#31302E',

      //icon

     'icon-primary': '#E7E6E2',
      'icon-secondary': '#A7A5A3',
      'icon-action-primary': '#FFFFFF',
      'icon-on-action-primary': '#FFFFFF',
      'icon-emphasis-secondary': '#a4adf2',
      'icon-success': '#4EB3A9',
      'icon-warning': '#E58733',
      'icon-info': '#FFFFFF',
      'icon-error': '#FF5757',
      'icon-emphasis-primary': '#636363',
      'icon-disabled': '#575655',
      'icon-primary-hover': '#212225'
    }

export const colorsForSupersetMoneyControlDarkMode = {
      'white': '#ffffff',
      'black': '#000000',
      //text colors
      'milk': '#F5F5F3',
      'chalk': '#EAE9E5',
      'text-primary': '#E7E6E2',
      'text-secondary': '#7D7D7D',
      'text-placeholder': '#8E8D8B',
      'text-disabled': '#8E8D8B',
  'text-emphasis-secondary': '#61D381',
      'text-action-primary': '#D7E47C',
  'text-action-primary-hover': '#A9B746',
      'text-on-action-primary': '#100F0F',
  'text-success': '#61D381',
  'text-warning': '#FFCA3C',
      'text-info': '#A7A5A3',
  'text-error': '#FF8F88',

      //bg-colors
      'bg-surface-page':'#0E0F10',
      'bg-surface-primary': '#100F0F',
      'bg-surface-secondary': '#31302E',
      'bg-surface-emphasis-primary': '#636363',
      'bg-surface-emphasis-secondary': '#4E5483',
  'bg-fill-primary': '#2A2D35',
      'bg-fill-secondary': '#343739',
      'bg-fill-emphasis-primary-1': '#31302e',
  'bg-fill-emphasis-primary-2': '#D2D5B1',
  'bg-fill-emphasis-secondary': '#152C1B',
  'bg-fill-success': '#153B20',
  'bg-fill-warning': '#1C1810',
  'bg-fill-error': '#3B1312',
      'bg-fill-info': '#262524',
      'bg-action-primary':  '#D7E47C',
      'bg-action-primary-hover': '#E7E6E2',
      'bg-action-disabled': '#31302E',

      //border
  'border-primary': '#2E3135',
  'border-secondary': '#414346',
      'border-emphasis-primary':'#8E8D8B',
      'border-emphasis-secondary':'#3B4064',
      'border-form': '#575655',
  'border-success': '#317D47',
  'border-warning': '#6A521E',
      'border-info': '#31302E',
  'border-error': '#B54543',
  'border-action': '#D7E47C',
      'border-action-hover': '#BBB9B7',
      'border-focus': '#A7A5A3',
      'border-disabled': '#31302E',

      //icon
     'icon-primary': '#E7E6E2',
      'icon-secondary': '#7D7D7D',
      'icon-action-primary': '#D7E47C',
  'icon-on-action-primary': '#1C2024',
      'icon-emphasis-secondary': '#a4adf2',
  'icon-success': '#61D381',
  'icon-warning': '#F1B60A',
  'icon-info': '#B0B4BA',
  'icon-error': '#DE4043',
  'icon-emphasis-primary': '#8D9C2D',
      'icon-disabled': '#575655',
      'icon-primary-hover': '#212225'
    }

const getColorPalletsMoneyControlLight = (defaultColorSet: any) => {
  return {
    ...defaultColorSet,
    'text-action-primary': '#8D9C2D',
    'text-action-primary-hover': '#A9B746',
    'text-on-action-primary': '#000000',
    'text-success': '#00813B',
    'text-warning': '#9C6E00',
    'text-error': '#CD2E35',
    'text-primary': '#1C2024',
    'text-secondary': '#60646C',
    'text-placeholder': '#8B8D98',
    'text-disabled': '#8B8D98',
    'text-emphasis-secondary': '#00813B',

    'bg-surface-page': '#FDFFED',
    'bg-surface-primary': '#FFFFFF',
    'bg-surface-secondary': '#F9F9FB',
    'bg-surface-emphasis-primary': '#FAFFDD',
    'bg-surface-emphasis-secondary': '#E6F7E9',
    'bg-fill-emphasis-primary-1': '#FAFFDD',
    'bg-fill-primary': '#FFFFFF',
    'bg-fill-secondary': '#F9F9FB',

    'bg-fill-emphasis-primary-2': '#8D9C2D',
    'bg-fill-emphasis-secondary': '#E6F7E9',

    'bg-fill-success': '#D7F2DB',
    'bg-fill-warning': '#FFFAE9',
    'bg-fill-error': '#FEEBEA',
    'bg-fill-info': '#F9F9FB',

    'bg-action-primary': '#D7E47C',
    'bg-action-primary-hover': '#8D9C2D',
    'bg-action-disabled': '#F9F9FB',

    'border-primary': '#E0E1E6',
    'border-secondary': '#F0F0F3',
    'border-emphasis-primary': '#EAF28D',
    'border-emphasis-secondary': '#8AD19A',
    'border-form': '#CDCED6',
    'border-success': '#56BC73',

    'border-warning': '#EBC067',
    // 'border-info': '#31302E',
    'border-error': '#EB8F89',
    'border-action': '#D7E47C',
    'border-action-hover': '#D7E47C',
    'border-focus': '#D7E47C',
    'border-disabled': '#CDCED6',

    'icon-primary': '#1C2024',
    'icon-secondary': '#80838D',
    'icon-action-primary': '#8D9C2D',
    'icon-on-action-primary': '#1C2024',
    'icon-emphasis-secondary': '#00813B',

    'icon-success': '#00813B',
    'icon-warning': '#F9BD20',
    'icon-info': '#8D9C2D',
    'icon-error': '#DE4043',
    'icon-emphasis-primary': '#D7E47C',
    'icon-disabled': '#B9BBC6',
    'icon-primary-hover': '#8D9C2D',
  }
}

export const colorsForSupersetOceanFinvest = (defaultColorSet: any) => {
  return {
    ...defaultColorSet,
    'bg-surface-primary': "#13172A",
    'bg-surface-page': "#13172A",
    'text-action-primary': "#0783C5",
    'bg-action-primary': "#0783C5",
    'text-action-primary-hover': "#0A5195",
    'border-action': "#0783C5",
    'border-focus': "#0783C5",
    'border-action-hover': "#0A5195",
    'icon-action-primary': "#0783C5",
    'bg-fill-emphasis-primary-2': "#0783C5"
  }
}

export const getThemeColorSetBasedOnPlatformCode = (
  defaultColorSet: any,
  platformCode?: string | undefined
) => {
  if (Platform.OS === 'web') {
    const params = getParameters(window.location.href);
    const ref = params['ref'] || null;
    const isDarkMode = useDarkMode();
    if (
      (
        ref === 'EAPWEU' ||
        ref === 'KSPGNC'
      ) &&
      isDarkMode
    ) {
      return colorsForSupersetOceanFinvest(defaultColorSet);
    }
  }
  if (platformCode === PLATFORM_NAME.DEZERV) {
    return colorsForSupersetDezerv;
  }
  if (platformCode === PLATFORM_NAME.MONEY_CONTROL) {
    const isDarkMode = useDarkMode();
    if (isDarkMode) {
      return colorsForSupersetMoneyControlDarkMode;
    } else {
      return getColorPalletsMoneyControlLight(defaultColorSet);
    }
  }
  return defaultColorSet;
}